import { useState, useEffect } from "react";

export function checkPageDirection() {
  const [isRTL, setIsRTL] = useState(
    document.documentElement.getAttribute("dir") === "rtl"
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const dir = document.documentElement.getAttribute("dir") || "ltr";
      setIsRTL(dir === "rtl");
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["dir"],
    });

    // in case the dir changed before observer runs
    const initialDir = document.documentElement.getAttribute("dir") || "ltr";
    setIsRTL(initialDir === "rtl");

    return () => observer.disconnect();
  }, []);

  return isRTL;
}
